import { Injectable, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { LoginModalComponent } from '../modals/login-modal/login-modal.component';

/**
 * Signs a lapsed session back in through the LoginModal for
 * `HttpInterceptorInterceptor`. Every 401 waiting on a sign-in shares one
 * modal. The generated ViveApi client sends its requests through HttpClient
 * too, so its 401s arrive here the same way.
 */
@Injectable({
  providedIn: 'root'
})
export class ReLoginService {
  private modalService = inject(NgbModal);

  /** The open LoginModal's outcome, shared so concurrent 401s wait on one modal. */
  private reLoginResult?: Promise<boolean>;

  /** Resolves true once the user signs in through the LoginModal, false if they dismiss it. */
  public awaitReLogin(): Promise<boolean> {
    if (!this.reLoginResult) {
      this.reLoginResult = this.modalService
        .open(LoginModalComponent, {
          backdrop: 'static'
        })
        .result.then(
          () => true,
          () => false
        )
        .finally(() => {
          this.reLoginResult = undefined;
        });
    }
    return this.reLoginResult;
  }
}
